// colaps sup O
const openCollaSup = document.querySelector(".container-eco")
const openCollatSupTrigger = document.querySelector(".btnsupO")
openCollatSupTrigger.addEventListener('click', addClassColapsSupO)

function addClassColapsSupO() {
  if (openCollaSup.classList.contains('h0pxO')) {
        const fullHeight = openCollaSup.scrollHeight + 'px'; // Get the actual height of the content
        openCollaSup.classList.remove('h0pxO')
        openCollaSup.style.height = fullHeight;
    } else {
        openCollaSup.style.height = '0px';
        openCollaSup.classList.add('h0pxO')
    };
  openCollatSupTrigger.classList.toggle('rot45sup');
}